import React from 'react';
//import partnerList from '../../data/partner/partnerList';
import Section from '../components/common/Section';
import { Row, Col } from 'reactstrap';
import bwGoogle from '../assets/img/logos/b&w/6.png';
import bwAmazon from '../assets/img/logos/b&w/10.png';

const Partner = props => (
  <Col xs={3} sm="auto" className="my-1 my-sm-3 px-card">
    <img className="landing-cta-img" {...props} alt="Partner" />
  </Col>
);

const Partners = () => {
  let partnerList = [{ src: bwGoogle, height: 40 }, { src: bwAmazon, height: 40 },];
  return (
    <Section bg="light" className="py-3 shadow-sm">
      <Row className="flex-center">
        {partnerList.map((partner, index) => (
          <Partner key={index} {...partner} />
        ))}
      </Row>
    </Section>
  );
};

export default Partners;
